import React, { useState } from "react";
import "../index.css";
import Footer from "../Footer";
import Header from "./Header";

export default function Morequiz() {
  document.title = "HR School - World GK";
  const questions = [
    {
      questionText: "What is the capital of France?",
      answerOptions: [
        { answerText: "New York", isCorrect: false },
        { answerText: "London", isCorrect: false },
        { answerText: "Paris", isCorrect: true },
        { answerText: "Dublin", isCorrect: false },
      ],
    },
    {
      questionText: "Who is CEO of Tesla?",
      answerOptions: [
        { answerText: "Jeff Bezos", isCorrect: false },
        { answerText: "Elon Musk", isCorrect: true },
        { answerText: "Bill Gates", isCorrect: false },
        { answerText: "Tony Stark", isCorrect: false },
      ],
    },
    {
      questionText: "The iPhone was created by which company?",
      answerOptions: [
        { answerText: "Apple", isCorrect: true },
        { answerText: "Intel", isCorrect: false },
        { answerText: "Amazon", isCorrect: false },
        { answerText: "Microsoft", isCorrect: false },
      ],
    },
    {
      questionText: "How many Harry Potter books are there?",
      answerOptions: [
        { answerText: "1", isCorrect: false },
        { answerText: "4", isCorrect: false },
        { answerText: "6", isCorrect: false },
        { answerText: "7", isCorrect: true },
      ],
    },
    {
      questionText: "Which one is the smallest ocean in the World?",
      answerOptions: [
        { answerText: "Indian", isCorrect: false },
        { answerText: "Pacific", isCorrect: false },
        { answerText: "Atlantic", isCorrect: false },
        { answerText: "Arctic", isCorrect: true },
      ],
    },
    {
      questionText: "Which river flowing through the Londoan City, England?",
      answerOptions: [
        { answerText: "River Severn", isCorrect: false },
        { answerText: "River Thames", isCorrect: true },
        { answerText: "River Severn", isCorrect: false },
        { answerText: "None of the above", isCorrect: false },
      ],
    },
    {
      questionText: "Which one is the tallest tower in the world?",
      answerOptions: [
        { answerText: "Tokyo Skytree, Japan", isCorrect: true },
        { answerText: "CN Tower, Canada", isCorrect: false },
        { answerText: "Canton Tower, China", isCorrect: false },
        { answerText: "KL Tower, Malaysia", isCorrect: false },
      ],
    },
    {
      questionText: "Only continent in the world without a desert is?",
      answerOptions: [
        { answerText: "North America", isCorrect: false },
        { answerText: "Asia", isCorrect: false },
        { answerText: "Asia", isCorrect: false },
        { answerText: "Europe", isCorrect: true },
      ],
    },
    {
      questionText: "Which one is the capital of Spain?",
      answerOptions: [
        { answerText: "Barcelona", isCorrect: false },
        { answerText: "Madrid", isCorrect: true },
        { answerText: "Seville", isCorrect: false },
        { answerText: "Lisbon", isCorrect: false },
      ],
    },
    {
      questionText: "Which country has the most number of lakes?",
      answerOptions: [
        { answerText: "Canada", isCorrect: true },
        { answerText: "USA", isCorrect: false },
        { answerText: "Finland", isCorrect: false },
        { answerText: "Brazil", isCorrect: false },
      ],
    },
  ];

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);

  const handleAnswerOptionClick = (isCorrect) => {
    if (isCorrect) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowScore(true);
    }
  };
  return (
    <>
      <Header />
      <br />
      <br />
      <center>
        <div className="quizapp">
          {showScore ? (
            <div className="score-section">
              You scored {score} out of {questions.length}
            </div>
          ) : (
            <>
              <div className="question-section">
                <div className="question-count">
                  <span>Question {currentQuestion + 1}</span>/{questions.length}
                </div>
                <div className="question-text">
                  {questions[currentQuestion].questionText}
                </div>
              </div>
              <div className="answer-section">
                {questions[currentQuestion].answerOptions.map(
                  (answerOption) => (
                    <button
                      id="quizbtn"
                      onClick={() =>
                        handleAnswerOptionClick(answerOption.isCorrect)
                      }
                    >
                      {answerOption.answerText}
                    </button>
                  )
                )}
              </div>
            </>
          )}
        </div>
      </center>
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </>
  );
}
